import { collectRoles, hasRole } from './roles';

const SUPER_IDS = new Set(['1001', '1002']);

function normalizeRoles(user) {
  try {
    const list = collectRoles(user);
    return Array.isArray(list) ? list : [];
  } catch {
    return [];
  }
}

export function resolveAccess(user) {
  const roles = normalizeRoles(user);
  const userId = String(user?.id || '');
  const isSuper = SUPER_IDS.has(userId);
  const hasAdminRole = hasRole(roles, 'admin');
  const hasGdRole = hasRole(roles, 'gd');
  const hasAssistantRole = hasRole(roles, 'assistant');
  const hasManagerRole = hasRole(roles, 'manager');
  const hasHrRole = hasRole(roles, 'hr');
  const hasTechRole = hasRole(roles, 'tech');

  const isAdmin = isSuper || hasAdminRole || hasGdRole;
  const techOnly = hasTechRole && !isAdmin && !hasAssistantRole && !hasManagerRole && !hasHrRole;
  const managerOnly = hasManagerRole && !isAdmin && !hasAssistantRole && !hasHrRole;
  const hrOnly = hasHrRole && !isAdmin && !hasAssistantRole && !hasManagerRole;

  const canAccess = {
    main: true,
    tmc: !techOnly && (isAdmin || hasAssistantRole || hasManagerRole),
    tmcRequests: !techOnly && (isAdmin || hasAssistantRole || hasManagerRole),
    hr: !techOnly && (isAdmin || hasHrRole),
    warehouse: isSuper || hasGdRole,
    cardCalc: isAdmin,
    objects: isAdmin,
    groups: isAdmin,
    supercontrol: isAdmin,
    closingDocs: isAdmin,
    payrolls: isAdmin,
    positions: isAdmin,
    adminUsers: isAdmin,
  };

  const canEdit = {
    tmc: isAdmin || hasAssistantRole,
    hr: isAdmin || hasHrRole,
  };

  const canSign = {
    managerStage: hasManagerRole || isAdmin,
    assistantStage: hasAssistantRole || isAdmin,
  };

  return {
    roles,
    isSuper,
    isAdmin,
    hasGdRole,
    hasAssistantRole,
    hasManagerRole,
    hasHrRole,
    hasTechRole,
    techOnly,
    managerOnly,
    hrOnly,
    canAccess,
    canEdit,
    canSign,
  };
}

export function resolvePathModule(pathname = '/') {
  const path = String(pathname || '/');
  if (path === '/' || path === '/login') return 'main';
  if (path === '/tmc' || path.startsWith('/tmc/')) return 'tmc';
  if (path === '/tmc-requests' || path.startsWith('/tmc-requests/')) return 'tmcRequests';
  if (path === '/warehouse' || path.startsWith('/warehouse/')) return 'warehouse';
  if (path === '/card-calc' || path.startsWith('/card-calc/')) return 'cardCalc';
  if (path === '/objects' || path.startsWith('/objects/')) return 'objects';
  if (path === '/groups' || path.startsWith('/groups/')) return 'groups';
  if (path === '/supercontrol' || path.startsWith('/supercontrol')) return 'supercontrol';
  if (path === '/closing-docs') return 'closingDocs';
  if (path === '/payrolls' || path.startsWith('/payrolls/')) return 'payrolls';
  if (path === '/positions') return 'positions';
  if (path === '/admin/users') return 'adminUsers';
  if (path === '/hr/employees' || path.startsWith('/hr/employees/')) return 'hr';
  return null;
}
